import en from './locales/en.json'
import es from './locales/es.json'

let messagesQueue = Promise.resolve()
let sequence = 0

function showMessage(message, confirmation) {
  // Queue notices instead of replacing an unanswered confirmation.
  const result = messagesQueue.then(() => new Promise(resolve => {
    const labels = (document.documentElement.lang.startsWith('en') ? en : es).user_dialog
    const opener = document.activeElement
    const dialog = document.createElement('dialog')
    const id = `user-message-${++sequence}`
    dialog.className = 'user-modal__panel user-message-dialog'
    dialog.setAttribute('aria-labelledby', `${id}-title`)
    dialog.setAttribute('aria-describedby', `${id}-body`)

    const title = document.createElement('h2')
    title.id = `${id}-title`
    title.className = 'user-modal__title'
    title.textContent = confirmation ? labels.confirm_title : labels.notice_title
    const body = document.createElement('p')
    body.id = `${id}-body`
    body.className = 'user-modal__body'
    // Server and camera error text must never become executable markup.
    body.textContent = String(message ?? '')
    const close = document.createElement('button')
    close.type = 'button'
    close.className = 'user-modal__close'
    close.setAttribute('aria-label', labels.close)
    const icon = document.createElement('span')
    icon.className = 'material-icons-sharp'
    icon.setAttribute('aria-hidden', 'true')
    icon.textContent = 'cancel'
    close.append(icon)
    close.addEventListener('click', () => dialog.close('cancel'))

    const actions = document.createElement('div')
    actions.className = 'user-modal__actions'
    let cancel
    if (confirmation) {
      cancel = document.createElement('button')
      cancel.type = 'button'
      cancel.className = 'user-message-dialog__cancel'
      cancel.textContent = labels.cancel
      cancel.addEventListener('click', () => dialog.close('cancel'))
      actions.append(cancel)
    }
    const accept = document.createElement('button')
    accept.type = 'button'
    accept.className = 'user-message-dialog__accept'
    accept.textContent = confirmation ? labels.confirm : labels.accept
    accept.addEventListener('click', () => dialog.close('accept'))
    actions.append(accept)
    dialog.append(close, title, body, actions)

    dialog.addEventListener('keydown', event => {
      if (event.key !== 'Tab') return
      const controls = [...dialog.querySelectorAll('button')]
      const first = controls[0]
      const last = controls[controls.length - 1]
      const destination = event.shiftKey && event.target === first ? last :
        (!event.shiftKey && event.target === last ? first : null)
      if (destination) {
        event.preventDefault()
        destination.focus()
      }
    })
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return
      const rect = dialog.getBoundingClientRect()
      if (event.clientX < rect.left || event.clientX > rect.right ||
          event.clientY < rect.top || event.clientY > rect.bottom) dialog.close('cancel')
    })
    dialog.addEventListener('close', () => {
      const accepted = dialog.returnValue === 'accept'
      dialog.remove()
      if (opener?.isConnected) opener.focus({ preventScroll: true })
      resolve(accepted)
    }, { once: true })
    document.body.append(dialog)
    dialog.showModal()
    ;(cancel || accept).focus()
  }))
  messagesQueue = result.catch(() => false)
  return result
}

window.ArcadiDialog = {
  alert: message => showMessage(message, false),
  confirm: message => showMessage(message, true)
}

// Opt in only the customer controls migrated from native confirm(). The
// confirmed click still follows its original Rails UJS/form/CSRF path.
const pending = new WeakSet()
const accepted = new WeakSet()
document.addEventListener('click', async event => {
  const control = event.target.closest?.('[data-user-confirm]')
  if (!control) return
  if (accepted.has(control)) {
    accepted.delete(control)
    return
  }
  event.preventDefault()
  event.stopImmediatePropagation()
  if (pending.has(control)) return
  pending.add(control)
  try {
    if (await window.ArcadiDialog.confirm(control.dataset.userConfirm) && control.isConnected) {
      accepted.add(control)
      control.click()
    }
  } finally {
    pending.delete(control)
    accepted.delete(control)
  }
}, true)
